import { Component } from "react"
import { withRouter } from "react-router-dom"
import * as Sentry from "@sentry/browser"
import ErrorMessage from "../ErrorMessage/ErrorMessage"

const DEFAULT_STATE = { hasError: false, error: null }

class ErrorBoundary extends Component {
  state = DEFAULT_STATE

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    }
  }

  // Clear errors when a user navigates to a different page
  componentDidUpdate(prevProps) {
    const { hasError } = this.state

    if (
      hasError &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState(DEFAULT_STATE)
    }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  render() {
    const { error, hasError } = this.state
    const DefaultErrorMessage = (
      <ErrorMessage
        message={`It looks like something went wrong. Try refreshing the page. Contact support if the problem persists (${error?.response?.status})`}
      />
    )
    const { fallback = DefaultErrorMessage, children } = this.props

    if (!hasError) {
      return children
    }

    return fallback
  }
}

export default withRouter(ErrorBoundary)
